// extracted by mini-css-extract-plugin
export default {"experienceSection":"Experience_experienceSection__KT4OA","experienceContent":"Experience_experienceContent__D3nS8"};